module.exports = __webpack_public_path__ + "img/gift6.b9a55870.png";